import { HttpInterceptorFn } from '@angular/common/http';
import { SKIP_WITH_CREDENTIALS_HTTP } from './skip-with-credentials-http.token';

export const withCredentialsInterceptor: HttpInterceptorFn = (req, next) => {
  const skipWithCredentials = req.context.get(SKIP_WITH_CREDENTIALS_HTTP) ?? false;
  if (skipWithCredentials) {
    const modifiedReq = req.clone({ withCredentials: false });
    return next(modifiedReq);
  }
  const modifiedReq = req.clone({ withCredentials: true });
  return next(modifiedReq);
};
